/**
 * Generate a unique SKU for an item
 * Format: PREFIX-YYYYMMDD-RANDOM
 * Example: CLO-20250205-A8F3
 */
export const generateSKU = (itemName) => {
  // Prefix from first 3 letters of item name
  const prefix = itemName
    .replace(/[^a-zA-Z]/g, '')
    .substring(0, 3)
    .toUpperCase()
    .padEnd(3, 'X');

  // Date component YYYYMMDD
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  const dateComponent = `${year}${month}${day}`;

  // Random alphanumeric component (4 characters)
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  let randomComponent = '';
  for (let i = 0; i < 4; i++) {
    randomComponent += chars.charAt(Math.floor(Math.random() * chars.length));
  }

  return `${prefix}-${dateComponent}-${randomComponent}`;
};

/**
 * Generate a variation SKU based on parent SKU
 * Format: PARENT_SKU-COLOR_CODE-SIZE_CODE
 * Example: CLO-20250205-A8F3-BLU-XL
 */
export const generateVariationSKU = (parentSKU, color, size) => {
  const colorCode = color
    .replace(/[^a-zA-Z]/g, '')
    .substring(0, 3)
    .toUpperCase()
    .padEnd(3, 'X');

  const sizeCode = size
    .replace(/[^a-zA-Z0-9]/g, '')
    .toUpperCase();

  return `${parentSKU}-${colorCode}-${sizeCode}`;
};

/**
 * Validate SKU format
 */
export const validateSKU = (sku) => {
  // Basic format check
  const pattern = /^[A-Z]{3}-\d{8}-[A-Z0-9]{4}(-[A-Z]{3}-[A-Z0-9]+)?$/;
  return pattern.test(sku);
};
